<template>
	<div @click="startTutorial" class="width-100 display-flex flex-row flex-align-center item-container">
		<v-img :src="subStepDetails.icon" class="preview-image-container height-100" />
		<div class="width-100 display-flex flex-row flex-align-center flex-justify-space-between height-100 px-5">
			<div class="display-flex flex-column description-container flex-justify-space-between height-100">
				<div class="tutorial-title">
					{{ subStepDetails.title }}
				</div>
				<div class="display-flex flex-row flex-align-center footer-text">
					<div>{{ numberOfOptionsLeftText }}</div>
					<div class="level-container px-1 ml-4 flex-centerize">
						{{ subStepDetails.level }}
					</div>
				</div>
			</div>
			<AnemicButton tile class="start-button">Start building</AnemicButton>
		</div>
	</div>
</template>

<script>
import { pluralize } from '@/utils/language-service';
export default {
	name: 'OnBoardingBuildYourFirstItem',
	props: { subStepDetails: { type: Object } },
	components: {},
	computed: {
		numberOfOptionsLeftText() {
			return pluralize('minute', this.subStepDetails.minutesToComplete, true);
		},
	},
	methods: {
		startTutorial() {
			const { subStepDetails } = this;
			this.$emit('startTutorial', { subStepDetails });
		},
	},
	created() {},
	data() {
		return {};
	},
};
</script>

<style scoped lang="scss">
.item-container {
	height: 100px;
	cursor: pointer;
	overflow: hidden;
	transition: 0.3s;
	border-radius: 10px;
	background: #f8f9fc;
	border: 1px solid #d6ddea;
	&:hover {
		background: #f2f3f3;
	}
	&:active {
		background: #ebecee;
	}
}
.preview-image-container {
	width: 160px;
	border-right: 1px solid #d6ddea;
	border-radius: 10px 0px 0px 10px;
}
.start-button {
	width: 165px !important;
	padding: 0px !important;
	height: 47px !important;
	font-size: 16px !important;
	border-radius: 10px !important;
	font-weight: normal !important;
	letter-spacing: 0px !important;
	color: var(--white) !important;
	background: #5d5ee1 !important;
}
.tutorial-title {
	font-size: 14px;
	line-height: 16px;
}
.description-container {
	max-width: 50%;
	letter-spacing: 0px;
	padding: 14px 0 14px 0;
	color: var(--primary-font-color);
}
.level-container {
	height: 18px;
	border-radius: 5px;
	background: #e7e9eb;
}
.footer-text {
	font-size: 11px;
	color: #5b6c7b;
}
</style>
